<template>
    <v-app-bar :clipped-left=true app :color="navbarcolor===''?'primary':navbarcolor" dark>
        <v-row dense class="app-flex-row" :class="{'app-flex-row-gap': !isMobileMenu()}">
            
            <!-- you can use an icon (mdi) as a picture on the left (not visible on mobile) -->
            <v-app-bar-nav-icon v-if="navbaricon!==''" :class="{'app-bar-gone': isMobileMenu()}">
                <v-icon large>{{ navbaricon }}</v-icon>
            </v-app-bar-nav-icon>

            <!-- if you use an icon you can not use the png (not visible on mobile) -->
            <div v-else class="app-bar-gradient" :class="{'app-bar-gone': xs||sm}">
                <img src="@/assets/vfy3.png" width="40px" class="app-bar-image"  @click="openTab('/dashboard')"/>
            </div>

            <!-- title (not visible on mobile) -->
            <v-toolbar-title class="pl-4" :class="{'app-bar-gone': isMobileMenu()}">
                <span v-html="title"></span>
            </v-toolbar-title>

            <!-- action menu + regular menu -->
            <v-toolbar-items v-if="Object.keys(menu).length!==0||actions.length!==0">

                <!-- for now there is only room for one action button with options -->
                <v-menu v-if="actions.length!==0" offset-y open-on-hover close-on-click>

                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" small class="pt-1 app-menu-button">Actions
                            <v-icon dark right small>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-list dense class="mx-0 px-0">
                        <div v-for="action in actions" :key="action.text">
                            <v-list-item @click="actionClick(action.action)" v-if="action.action !== 'divider'">
                                <v-list-item-title>{{ action.text }}</v-list-item-title>
                            </v-list-item>
                            <v-divider v-if="action.action === 'divider'"/>
                        </div>
                    </v-list>

                </v-menu>                    

                <!-- regular menu -->
                <div :class="{'app-bar-items' :xs||sm}">
                    <v-menu v-for="(menu, i) in menu.menu" :key="i" offset-y open-on-hover close-on-click class="mx-0 px-0" >
                        <!-- Menu Option -->
                        <template v-slot:activator="{ on }">
                            <v-avatar size="40" v-on="on" small class="app-avatar pr-2" :class="colorChoice&&index===i ? 'blue' : ''" @click="doMenu(index, menu)" v-if="menu.menu_avatar">
                                <v-icon dark right>{{ menu.menu_avatar }}</v-icon>
                            </v-avatar>
                            <!-- <v-avatar size="40" v-on="on" class="pt-1" :class="colorChoice&&index===i ? 'blue' : ''" v-if="menu.menu_avatar"></v-avatar> -->
                            <v-btn text v-on="on" small class="pt-1" :class="colorChoice&&index===i ? 'blue' : ''" @click="doMenu(i, menu)" v-if="!menu.menu_avatar">{{ menu.menu_titel }}
                                <v-icon dark right small v-if="menu.item.length > 0">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        
                        <!-- Menu Sub Option -->
                        <v-list dense class="mx-0 px-0" @click="saveClick(i)" v-if="menu.item.length > 0">
                            <div v-for="item in menu.item" :key="item.item_titel">
                                <v-list-item :disabled="item.item_disabled" router :to="item.item_route" v-if="item.item_type==='route'" style="font-size: 6pt !important">
                                    <v-list-item-title>
                                        {{ item.item_titel }} 
                                        <v-icon 
                                            v-if="item.item_icon_right!==''" 
                                            :size="item.item_icon_right_size===0?15:item.item_icon_right_size" 
                                            class="ml-2"
                                        >
                                            {{ item.item_icon_right }}
                                        </v-icon>
                                    </v-list-item-title>
                                </v-list-item>                            
                                <v-list-item :disabled="item.item_disabled" @click="openTab(item.item_route)" v-if="item.item_type==='newtab'" style="font-size: 6pt !important">
                                    <v-list-item-title>
                                        {{ item.item_titel }} 
                                        <v-icon 
                                            v-if="item.item_icon_right!==''" 
                                            :size="item.item_icon_right_size===0?15:item.item_icon_right_size" 
                                            class="ml-2"
                                        >
                                            {{ item.item_icon_right }}
                                        </v-icon>
                                    </v-list-item-title>
                                </v-list-item>                            
                                <v-list-item :disabled="item.item_disabled" @click="actionClick(item.item_action)" v-if="item.item_type==='action'" style="font-size: 6pt !important">
                                    <v-list-item-title>
                                        {{ item.item_titel }} 
                                        <v-icon 
                                            v-if="item.item_icon_right!==''" 
                                            :size="item.item_icon_right_size===0?15:item.item_icon_right_size" 
                                            class="ml-2"
                                        >
                                            {{ item.item_icon_right }}
                                        </v-icon>
                                    </v-list-item-title>
                                </v-list-item>                            
                                <v-divider v-if="item.item_type === 'divider'"/>
                            </div>
                        </v-list>

                    </v-menu>
                </div>

                <router-view :key="$route.fullPath"></router-view>

            </v-toolbar-items>

            <!-- attm, email and nott buttons go here -->
            <div class="app-button-flex">
                <v-btn icon @click="actionClick('m_attm')" v-if="attms >= 0" class="pt-1"><v-icon small class="mr-1">mdi-attachment</v-icon>{{ attms }}</v-btn>
                <v-btn icon @click="actionClick('nott')" v-if="notts>= 0" class="pt-1"><v-icon small class="mr-1">mdi-briefcase-outline</v-icon>{{ notts }}</v-btn>
                <v-btn icon @click="actionClick('mails')" v-if="mails>= 0" class="pt-1"><v-icon small class="mr-1">mdi-email-fast-outline</v-icon>{{ mails }}</v-btn>
            </div>

            <!-- info panel goes here (not visible on mobile) -->
            <div v-if="info.length>=0" class="app-info-flex" :class="{'app-bar-gone': isMobileMenu()}">
                <div v-for="(inf, idx) in info" :key="inf.label" class="app-info-flex">                    
                    <div class=mr-2>{{ inf.label }}</div>
                    <div>{{ inf.value }}</div>
                    <div v-if="(idx + 1)<info.length" class="ml-4 mr-4 large-char">|</div>
                </div>
            </div>

            <div class="app-push-right app-button-flex">
                <!-- (not visible on mobile) -->
                <div :class="{'app-bar-gone': isMobileMenu()}" v-if="download">
                    <download_button @actionClick="actionClick"/>
                </div>
                <!-- (not visible on mobile) -->
                <div :class="{'app-bar-gone': isMobileMenu()}" v-if="goto!==''">
                    <goto_button @actionClick="gotoClick(goto)"/>
                </div>
                <!-- (not visible on mobile) -->
                <div :class="{'app-bar-gone': isMobileMenu()}" v-if="accolist">
                    <accolist_button/>
                </div>
                <!-- always visible since the "main menu" button is gone -->
                <home_button v-if="home"/>
            </div>    
                 
        </v-row>
    </v-app-bar>
</template>

<script>

    import home_button from '@/components/ui/buttons/home_button.vue';
    import accolist_button from '@/components/ui/buttons/accolist_button.vue';
    import download_button from '@/components/ui/buttons/download_button.vue';
    import goto_button from '@/components/ui/buttons/goto_button.vue';

    export default {
        props: {
            title: String,
            home: {
                type: Boolean,
                default: false
            },
            accolist: {
                type: Boolean,
                default: false
            }, 
            download: {
                type: Boolean,
                default: false
            },   
            goto: {
                type: String,
                default: ''
            },                     
            type: {
                type: String,
                default: ''
            },
            attms: {
                type: Number,
                default: -1,
            },
            notts: {
                type: Number,
                default: -1,
            },
            mails: {
                type: Number,
                default: -1,
            },      
            actions: {
                type: Array,
                default: function() {return [];}
            },    
            info: {
                type: Array,
                default: function() {return [];}
            },             
            navbaricon: {
                type: String,
                default: ''
            },
            navbarcolor: {
                type: String,
                default: ''
            },
            data: {
                type: String,
                required: false,
                default: "",
            },
            colorChoice: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        components: {
            home_button,
            accolist_button,
            download_button,
            goto_button
        },    
        data() {
            return {
                menu: {},
                index: 0,
            }
        },
        methods: {
            getMenuByType() {
                if(this.type !== '') {
                    this.$axios.post("ares/json/ares/syst/menu/getMenu.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getMenu"
                        },
                        getMenu: {
                            menu: this.type,
                            data: this.data,
                        }
                    }).then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.$session.destroy();
                            this.$router.push("/");
                        } else {
                            this.menu = res.data.getMenu;
                            let i = sessionStorage.getItem('menuIndex');
                            if (typeof(i) === "string") {
                                this.index = parseInt(i);
                            }
                        }
                    });  
                }              
            },
            openTab(page) {
                if (this.type !== 'photographer'){
                    this.$router.open(page);
                }
            },
            actionClick(action){
                this.$emit('actionClick', action);
            },      
            isMobileMenu(){
                return this.xs||this.sm||this.md
            }, 
            doMenu(i, menu) {
                this.saveClick(i);
                if (menu.item_type === 'route') {
                    let route = this.$router.resolve({ path: menu.item_route }); 
                    window.open(route.href, "_self");                    
                }
                if (menu.item_type === 'action') {
                    this.actionClick(menu.item_action);
                }
            },
            gotoClick(page) {
                if (page !== '') {
                    if (this.$route.path !== page) {
                        this.$router.push(page);
                    }
                }
            },
            saveClick(i) {
                this.index = i;
                sessionStorage.setItem('menuIndex', i.toString());
            },
        },
        created() {
            this.getMenuByType();
        },
        computed:{
            xs: function(){
                return this.$vuetify.breakpoint.name === 'xs';
            },
            sm: function(){
                return this.$vuetify.breakpoint.name === 'sm';
            },      
            md: function(){
                return this.$vuetify.breakpoint.name === 'md';
            },                                      
        },       
    }
</script>

<style scoped>
.app-flex-row {
    display: flex;
    align-items: center;
}
.app-flex-row-gap{
    gap: 2em;
}
.app-push-right{
    margin-left: auto;
}
.app-button-flex{
    display: flex;
    column-gap: 15px;
    align-items: center;
}
.app-info-flex{
    display: flex;
    align-items: center;
    font-size: small;
}
.large-char{
    font-size: large;
}
.app-bar-gradient{    
    height: 50px;
    width: 50px; 
    border-radius: 50%;
    border: 1px solid;
    background-image: radial-gradient(#42A5F5 15%, #1976D2 60%);
    display: flex;
    flex-direction: column;
    align-items: center;
}
.app-bar-image{
    margin-top: auto;
    margin-bottom: auto;
}
.app-bar-items{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 80vw;
}
.app-bar-gone{
    display: none;
}
.app-menu-button {
    color: white;
}
.app-menu-button-selected {
    color: red;
}
.app-avatar:hover {
    background-color: #2B81D6;
    cursor: pointer;
}
</style>